// Selected work (spec §3.4, §4). One real project at launch; two placeholders
// the spec names explicitly — now art-directed with studio-generated imagery
// (honestly labeled "case study in progress" in the narrative). Each case
// renders through CaseLayout: hero image, three-paragraph narrative (the
// situation, what we built, what changed), supporting image pair, optional
// pull quote, next-project teaser.

export const WORK = [
  {
    slug: 'bells-and-whistles',
    title: 'Bells & Whistles',
    line: 'Luxury mobile detailing, San Fernando Valley & Greater LA.',
    image: '/ext/media/work-bells.jpg',
    imageAlt: 'Black car with gold detail, from the client shoot',
    images: [
      { src: '/ext/media/work-bells-detail-1.jpg', alt: 'Water beading on freshly detailed gold paint' },
      { src: '/ext/media/work-bells-detail-2.jpg', alt: 'Detailed alloy wheel and dressed tire under studio light' },
    ],
    wide: { src: '/ext/media/work-bells-detail-3.jpg', alt: 'Gold coupe in full profile under studio rim light' },
    deliverables: ['Brand system', 'Production site + online booking', 'Photography direction', 'Six-month presence engagement'],
    narrative: [
      'Bells & Whistles details high-end cars at their owners\u2019 homes across the Valley and Greater LA. The work was excellent; the presence wasn\u2019t. A demo site, no booking, and photography that undersold cars worth six figures.',
      'We built the brand system and the production site as one piece: a black-and-gold identity applied end to end, a scheduling engine customers actually use — pick a package, pick a slot, done — and a shoot of the real work on real clients\u2019 cars.',
      'The site went from demo to production with online booking live from day one, and a six-month presence engagement keeps the photography, offers, and campaigns moving with the season.',
    ],
    scope: 'Demo-to-production site build, brand system, and a six-month presence engagement.',
  },
  {
    slug: 'harlow-goods',
    title: 'Harlow Goods',
    line: 'Small-batch home goods. Identity and packaging refresh.',
    image: '/ext/media/work-harlow-hero.jpg',
    imageAlt: 'Ceramics, linen, and kraft packaging with sea-blue labels on plaster',
    images: [
      { src: '/ext/media/work-harlow-detail-1.jpg', alt: 'Turquoise glaze meeting raw clay on a hand-thrown vessel' },
      { src: '/ext/media/work-harlow-detail-2.jpg', alt: 'Label system flat-lay: kraft boxes, tissue, twine, wax seal' },
    ],
    wide: { src: '/ext/media/work-harlow-detail-3.jpg', alt: 'The full line on plaster niche shelves, packaging alongside' },
    deliverables: ['Wordmark & lockups', 'Label & packaging system', 'Print-shop guardrails'],
    narrative: [
      'A small-batch home goods maker whose products outgrew their first labels. The line was expanding; the identity was holding it back.',
      'An identity and packaging refresh: a wordmark that sets the tone, a label system that scales across the line, and the guardrails to keep it consistent at the print shop.',
      'Case study in progress — the full write-up lands here once the work ships.',
    ],
    scope: 'Identity and packaging refresh.',
  },
  {
    slug: 'field-and-frame',
    title: 'Field & Frame',
    line: 'An architecture studio. Site and portfolio system.',
    image: '/ext/media/work-field-hero.jpg',
    imageAlt: 'White plaster volumes and a turquoise door under a deep blue sky',
    images: [
      { src: '/ext/media/work-field-detail-1.jpg', alt: 'Curved plaster staircase in raking light' },
      { src: '/ext/media/work-field-detail-2.jpg', alt: 'Turquoise shutter on a white facade against blue sky' },
    ],
    wide: { src: '/ext/media/work-field-detail-3.jpg', alt: 'Vaulted plaster hallway opening to the sea' },
    deliverables: ['Site design & build', 'Portfolio system', 'Project narrative structure'],
    narrative: [
      'An architecture studio with a decade of built work and no good way to show it. The portfolio lived in PDFs; the site said little.',
      'A site and portfolio system built around the work itself: full-bleed photography, project narratives, and a structure the studio can extend with each new commission.',
      'Case study in progress — the full write-up lands here once the work ships.',
    ],
    scope: 'Site and portfolio system.',
  },
];

export const workBySlug = (slug) => WORK.find((w) => w.slug === slug);
